/** 認証 */
import DriverAuthentication from "./authentication";

/**初期パスワード変更 */
import DriverInitialPassword from "./initial_password";

/** Me */
import DriverMe from "./me";

import DriverAppVariable from "./app_variable"

/** 電子契約 認可コード */
import DriveContractAuthorize from "./contract_authorize";

/** テナント情報 */
import DriverTenant from "./tenant";

/** 外部連携 */
import DriverProviderSetting from "./provider_setting";

/** パスワード忘れ */
import DriverRecovery from "./recovery";
import DriverForget from "./forget";

/**アクティベート(招待) */
import DriverActivate from "./activate";

/** ダッシュボード 回収件数 */
import DriverDashboardCollect from "./dashboard/collect";

/** ダッシュボード DXE_JWNET起票件数/回収件数 */
import DriverDashboardDrafting from "./dashboard/drafting";

/** ダッシュボード 受注一覧 */
import DriverDashboardManifest from "./dashboard/manifest";
/** ダッシュボード */
import DriverDashboardAccepts from "./dashboard/accept";

/** ダッシュボード ドライバー一覧 */
import DriverDashboardDriver from "./dashboard/driver";

/** ダッシュボード ドライバーステータス */
import DriverDashboardDriverStatus from "./dashboard/drivers/status";

/** ダッシュボード 利用状況 */
import DriverDashboardTenantTask from "./dashboard/tenant_task";

/** ダッシュボード　DXEより電子マニフェスト(EDI)に関するお知らせがあります */
import DriverDashboardFailureReport from "./dashboard/failure_report";

/** 受注 */
import DriverOrderAccept from "./orders/accept";

/** 受注一覧 CSV出力予約 */
import DriverOrderAcceptOutputReservation from "./orders/accepts/output_reservation";

/** 受注 ステータス件数 */
import DriverOrderAcceptSummary from "./orders/accepts/summary";

/** 受注詳細 受注一覧(dialog) */
import DriverOrderSearchAccept from "./orders/search/accepts";

/** 受注詳細 */
import DriverOrdersAcceptManifest from "./orders/accepts/manifest";

/** 受注 予約登録 */
import DriverOrderAcceptCollectionReservation from "./orders/accepts/collections/reservation";

/** 受注 キャンセル登録 */
import DriverOrderAcceptCollectionCancellation from "./orders/accepts/collections/cancellation";

/** 受注 排出持込予約登録 */
import DriverOrderSelfEmissionReservation from "./orders/accepts/self_emissions/reservation";

/** 受注 排出持込一括本登録 */
import DriverOrderSelfEmissionDefinitiveRegistration from "./orders/accepts/self_emissions/definitive_registration";

/** 引取 */
import DriverOrderAcceptPickup from "./orders/accepts/pickup";

/** 複写する受注一覧 */
import DriverOrderAcceptDuplicateOrder from "./orders/accepts/duplicate_order";

/** 受入ステータス件数 */
import DriverOrderReceiveSummary from "./orders/receives/summary";

/** 受入 処分終了報告 */
import DriverOrderReceiveCompletion from "./orders/receives/completion";

/** 受入 最終処分終了報告 */
import DriverOrderReceiveFinalCompletion from "./orders/receives/final_completion";

/** 搬入受注新規・更新 */
import DriverOrderAcceptCarryIn from "./orders/accepts/carry_in";

/** 搬入予約からの受注登録 */
import DriverOrderAcceptCarryInRegistration from "./orders/accepts/carry_ins/registration";

/** 産廃回収 */
import DriverOrderAcceptCollection from "./orders/accepts/collection";

import DriverOrderAcceptBackorder from "./orders/accepts/backorder";

/** 新規登録（回収）仮保存 */
import DriverOrderAcceptCollectionProvisional from "./orders/accepts/collections/provisional";

/** 産廃回収からの受注登録 初期表示 */
import DriverOrderAcceptCollectionRegistration from "./orders/accepts/collections/registration";

/** 産廃回収からの受注登録 受付通知 */
import DriverOrderAcceptCollectionRegistrationReception from "./orders/accepts/collections/registrations/reception";

/** 産廃回収からの受注登録 仮保存 */
import DriverOrderAcceptCollectionRegistrationProvisional from "./orders/accepts/collections/registrations/provisional";

/** 産廃回収からの受注登録 否決通知 */
import DriverOrderAcceptCollectionRegistrationRejection from "./orders/accepts/collections/registrations/rejection";

/** 受注 変更履歴 */
import DriverOrderAcceptCollectionRevisionHistory from "./orders/accepts/collections/revision_history";

/** 産廃回収 回収日編集 */
import DriverOrderAcceptCollectionCollect from "./orders/accepts/collections/collect";

/** 産廃回収 排出事業者編集 */
import DriverOrderAcceptCollectionEmission from "./orders/accepts/collections/emission";

/** 産廃回収 ドライバー指示メモ編集 */
import DriverOrderAcceptCollectionDriverInstruction from "./orders/accepts/collections/driver_instraction";

/** 産廃回収 廃棄物編集 */
import DriverOrderAcceptCollectionWaste from "./orders/accepts/collections/waste";

/** 産廃回収 連絡番号編集 */
import DriverOrderAcceptCollectionContactNumber from "./orders/accepts/collections/contact_number";

/** 産廃回収 JWNET備考編集 */
import DriverOrderAcceptCollectionTransportNote from "./orders/accepts/collections/transport_note";

/** 産廃回収 運搬方法編集 */
import DriverOrderAcceptCollectionTransportLocation from "./orders/accepts/collections/transport_location";

/** 産廃回収 処分方法編集 */
import DriverOrderAcceptCollectionDisposerLocation from "./orders/accepts/collections/disposer_location";

/** 産廃回収 排出承認メール再申請 */
import DriverOrderAcceptCollectionSendMailApproval from "./orders/accepts/collections/send_mail_approval";

/** 積替運搬からの受注登録 */
import DriverOrderAcceptPickupRegistration from "./orders/accepts/pickups/registration";

/** 積替運搬からの受注登録 */
import DriverOrderAcceptPickupRegistrationReception from "./orders/accepts/pickups/registrations/reception";

/** 積替運搬からの受注登録 否決通知 */
import DriverOrderAcceptPickupRegistrationRejection from "./orders/accepts/pickups/registrations/rejection";

/** 搬入予約からの受注登録 受付通知 */
import DriverOrderAcceptCarryInRegistrationReception from "./orders/accepts/carry_ins/registrations/reception";

/** 搬入予約からの受注登録 否決通知 */
import DriverOrderAcceptCarryInsRegistrationRejection from "./orders/accepts/carry_ins/registrations/rejection";

/** 産廃回収(登録完了)、積替運搬（登録完了）のキャンセル */
import DriverOrderAcceptDirectlyCancel from "./orders/accepts/directly_cancel";

/** 産廃回収(登録完了)、積替運搬（登録完了）の削除 */
import DriverOrderAcceptDirectlyHidden from "./orders/accepts/directly_hidden";

/** 積替運搬 登録完了登録 */
import DriverOrderAcceptDirectlyComplete from "./orders/accepts/directly_complete";

/** 発注（積替・搬入）*/
import DriverOrderRequest from "./orders/request";

/** 発注ステータスごとの件数 */
import DriverOrderSummary from "./orders/summary";

/** 発注 積替運搬 */
import DriverOrderRequestsPickup from "./orders/requests/pickup";

/** 発注 搬入予約 */
import DriverOrderRequestsCarryIn from "./orders/requests/carry_in";

/** 搬入予約 登録完了登録 */
import DriverOrderRequestsDirectlyComplete from "./orders/requests/directly_complete";

/** DXE受渡確認票 */
import DriverOrderConfirmationSlip from "./orders/confirmation_slip";

/** 一覧表 */
import DriverOrderConfirmationList from "./orders/confirmation_list";

/** 運搬終了報告 ダイアログ表示前バリデーション */
import DriverOrderReportConfirmationVerification from "./orders/report_confirmations/verification";

/** 受渡確認票 別タブ表示前バリデーション */
import DriverOrderConfirmationSlipVerification from "./orders/confirmation_slips/verification";

/** 一覧表 別タブ表示前バリデーション */
import DriverOrderConfirmationListVerification from "./orders/confirmation_lists/verification";

/** 利用申込書(A/B) */
import DriverJwnetJoinApplicationForm from "./masters/tenants/jwnet_join_application_form";

/** 利用申込書(C) */
import DriverJwnetEdiApplicationForm from "./masters/tenants/jwnet_edi_application_form";

/** 受注・発注 運搬終了報告 ダイアログ表示 */
import DriverOrderCompletionReport from "./orders/completion_report";

/** 受注・発注 処分終了報告 ダイアログ表示 */
import DriverOrderDisposalReport from "./orders/disposal_report";

/** 受注・発注 最終処分終了報告 ダイアログ表示 */
import DriverOrderFinalDisposalReport from "./orders/final_disposal_report";

/** 処分場受入 再資源化 最終処分終了報告 */
import DriverOrderRecycleFinalDisposalReport from "./orders/recycle_final_disposal_report";

/** 処分場受入 */
import DriverAcceptance from "./acceptance";

/** 処分場受入 処分登録 */
import DriverAcceptanceDirectlyComplete from "./acceptances/directly_complete";

/** 受注(マニフェスト */
import DriverManifest from "./manifest";

/** 一括本登録 */
import DriverManifestBulkRegistManifest from "./manifest/bulk_regist_manifest";

/** １次２次紐付け */
import DriverManifestLinkage from "./manifest/linkage";

/** １次２次紐付け 新規作成ボタン押下バリデーション */
import DriverManifestLinkageVerification from "./manifest/linkages/verification";

/** １次２次紐付け(本登録) */
import DriverManifestLinkageRegistration from "./manifest/linkages/registration";

/** １次２次紐付け(予約登録) */
import DriverManifestLinkageReservation from "./manifest/linkages/reservation";

/** 受注ステータスごとの件数 */
import DriverManifestSummary from "./manifests/summary";

/** 受注一覧(複写) */
import DriverDuplicateManifest from "./manifests/duplicate_manifest";

/** 受注(複写) */
import DriverDuplicateManifestDetail from "./manifests/duplicate";

/** 紐付け保守 */
import DriverManifestPreviously from "./manifest/previously";

import DriverManifestRelation from "./manifest/relation";

/** 運搬終了報告 区間切替 */
import DriverManifestManifestDetail from "./manifest/manifest_detail";

/** 排出事業者情報 */
import DriverManifestMaintenanceEmission from "./manifests/emission";

/** 回収報告 */
import DriverManifestMaintenanceCollectionReport from "./manifests/collection_report";

/** ドライバー指示メモ */
import DriverManifestMaintenanceDriverInstruction from "./manifests/driver_instruction";

/** 回収日項目 */
import DriverManifestMaintenanceCollect from "./manifests/collect";

/** 廃棄物情 */
import DriverManifestMaintenanceWaste from "./manifests/waste";

/** 運搬完了報告 */
import DriverManifestMaintenanceTransportComplete from "./manifests/transport_complete";

/**  */
import DriverManifestMaintenanceNote from "./manifests/note";

/** 運搬先事業場情報 */
import DriverManifestMaintenanceTransportLocation from "./manifests/transport_location";

/** 処分事業場情報 */
import DriverManifestMaintenanceDisposerLocation from "./manifests/disposer_location";

/** 予約登録 */
import DriverManifestReservationProcess from "./manifests/reservation_process";

/** 運搬終了報告 */
import DriverManifestCompletionProcess from "./manifests/completion_process";

/** 変更履歴 */
import DriverManifestChangeHistory from "./manifests/manifest_change_history";

/** マニフェスト管理 */
import DriverManifestManagement from "./manifest/management";

/** マニフェスト管理 CSV出力予約 */
import DriverManifestManagementOutputReservation from "./manifest/managements/output_reservation";

/** マニフェスト管理(本登録) */
import DriverManifestManagementRegistration from "./manifest/managements/registration";

/** マニフェスト管理(予約登録) */
import DriverManifestManagementReservation from "./manifest/managements/reservation";

/** 複写して新規登録 */
import DriverManifestManagementDuplicate from "./manifest/managements/duplicate";

/** マニフェスト管理: マニフェスト */
import DriverManifestManagementsManifest from "./manifest/managements/manifest";

/** マニフェスト管理: マニフェスト詳細 */
import DriverManifestManagementsManifestTransport from "./manifest/managements/manifest_transport";

/** マニフェスト管理: 受注番号更新 */
import DriverManifestManagementOrder from "./manifest/managements/order";

/** マニフェスト管理: 処分終了報告 */
import DriverManifestManagementDisposal from "./manifest/managements/disposal";

/** マニフェスト管理: 最終処分終了報告 */
import DriverManifestManagementFinalDisposal from "./manifest/managements/final_disposal";

/** マニフェスト管理 表示(紙・Web) */
import DriverManifestRestManifest from "./manifest/rest_manifest";

/** マニフェスト編集・取消(紙・Web) */
import DriverManifestRestManifestManifest from "./manifest/rest_manifests/manifest";

/** 運搬報告修正・取消(紙・Web) */
import DriverManifestRestManifestTransport from "./manifest/rest_manifests/manifest_transport";

/** 処分報告修正・取消(紙・Web) */
import DriverManifestRestManifestDisposal from "./manifest/rest_manifests/disposal";

/** 最終処分報告取消(紙・Web) */
import DriverManifestRestManifestFinalDisposal from "./manifest/rest_manifests/final_disposal";

/** 産廃回収 排出事業者編集 */
import DriverManifestManagementEmission from "./manifest/managements/emission";

/** 産廃回収 廃棄物編集 */
import DriverManifestManagementWaste from "./manifest/managements/waste";

/** 産廃回収 引渡し日編集 */
import DriverManifestManagementCollect from "./manifest/managements/collect";

/** 産廃回収 連絡番号編集 */
import DriverManifestManagementContactNumber from "./manifest/managements/contact_number";

/** 産廃回収 JWNET備考編集 */
import DriverManifestManagementTransportNote from "./manifest/managements/transport_note";

/** 産廃回収 運搬方法編集 */
import DriverManifestManagementTransportLocation from "./manifest/managements/transport_location";

/** 産廃回収 処分方法編集 */
import DriverManifestManagementDisposerLocation from "./manifest/managements/disposer_location";

/** マニフェスト管理 マニフェストカスタムラベル編集 */
import DriverManifestManagementManifestCustomLabel from "./manifest/managements/manifest_custom_label";

/** マニフェスト管理 排出承認メール送信 */
import DriverManifestManagementSendMailApproval from "./manifest/managements/send_mail_approval";

/** マニフェスト管理: 紙マニ返却日 */
import DriverManifestPaperRegister from "./manifest/paper_register";

/** マニフェスト検索キーワード */
import DriverManifestManagementManifestSearchKeyword from "./manifest/managements/manifest_search_keyword";

/** DXE受渡確認票 */
import DriverManifestConfirmationSlip from "./manifest/confirmation_slip";

/** 一覧表 別タブ表示前バリデーション */
import DriverManifestConfirmationList from "./manifest/confirmation_list";

/** 運搬終了報告,処分終了報告,最終処分終了報告 ダイアログ表示前バリデーション */
import DriverManifestReportConfirmationVerification from "./manifest/report_confirmations/verification";

/** 受渡確認票 別タブ表示前バリデーション */
import DriverManifestConfirmationSlipVerification from "./manifest/confirmation_slips/verification";

/** 一覧表 別タブ表示前バリデーション */
import DriverManifestConfirmationListVerification from "./manifest/confirmation_lists/verification";

/** マニフェスト管理: 運搬終了報告 */
import DriverManifestCompletionReport from "./manifest/completion_report";

/** マニフェスト管理: 処分終了報告 */
import DriverManifestDisposalReport from "./manifest/disposal_report";

/** マニフェスト管理: 最終処分終了報告 */
import DriverManifestFinalDisposalReport from "./manifest/final_disposal_report";

/** マニフェスト管理: 最終処分終了報告(再資源化対応) */
import DriverManifestRecycleFinalDisposalReport from "./manifest/recycle_final_disposal_report"

/** 搬入・引取連絡 */
import DriverManifestRequest from "./manifest/request";

/** 搬入・引取連絡 紐づきマニフェスト */
import DriverManifestMapRequest from "./manifest/map_request";

/** 搬入・引取 搬入予約 */
import DriverManifestRequestsCarryIn from "./manifest/requests/carry_in";

/** 搬入・引取 搬入予約 */
import DriverManifestRequestsPickup from "./manifest/requests/pickup";

/** 配車計画 ドライバー一覧 */
import DriverAllocateEntryDriver from "./allocate/entries/driver";

/** 配車計画 最終更新 */
import DriverAllocateEntryLastUpdate from "./allocate/entries/last_update";

/** 配車計画 ドライバー配車一覧 */
import DriverAllocateEntryDriverSchedule from "./allocate/entries/drivers/schedule";

/** 配車計画 ドライバー配車車両 */
import DriverAllocateEntryDriverScheduleVehicle from "./allocate/entries/drivers/schedules/vehicle";

/** 配車計画 その他指示 */
import DriverAllocateEntryDriverInstruction from "./allocate/entries/drivers/instruction";

/** 配車計画 ドライバー指示メモ */
import DriverAllocateEntryManifestDriverInstruction from "./allocate/entries/manifests/driver_instruction";

/** その他配車指示 入力履歴 */
import DriverAllocateInstructionHistory from "./allocate/instruction_history";

/** 配車計画 運搬統合 */
import DriverAllocateEntryDriverDestination from "./allocate/entries/drivers/destination";

import DriverAllocateEntryDriverAssign from "./allocate/entries/drivers/assign";

import DriverAllocateEntryDriverRelease from "./allocate/entries/drivers/release";

import DriverAllocateEntrySwitchDriver from "./allocate/entries/switch_driver";

/** 配車確定 */
import DriverAllocateEntryDispatch from "./allocate/entries/dispatch";

/***/
import DriverAllocateEntryNonAllocation from "./allocate/entries/non_allocation";

/***/
import DriverAllocateEntryUrgentAllocation from "./allocate/entries/urgent_allocation";

/***/
import DriverAllocateEntryUnspecifiedAllocation from "./allocate/entries/unspecified_allocation";

/** アサイン一覧 */
import DriverAllocateEntryAssign from "./allocate/entries/assign";

/***/
import DriverAllocateEntryDriverDispatchedSchedule from "./allocate/entries/drivers/dispatched_schedule";

/** 売上請求管理(取引管理)*/
import DriverSalesDeal from "./sales/deal";

/** 取引管理 仮保存 */
import DriverSalesDealProvisional from "./sales/deals/provisional";

/** 取引管理 本登録 */
import DriverSalesDealReception from "./sales/deals/reception";

/** 売上管理 伝票出力 */
import DriverSalesDealOutput from "./sales/deals/output";

/** 売上請求管理(取引管理) 複写 */
import DriverSalesDealDuplicate from "./sales/deals/duplicate";

/** 売上請求管理(請求管理)*/
import DriverSalesRequest from "./sales/request";

/** 売上請求管理(請求管理) 詳細 */
import DriverSalesRequestBillingDetail from "./sales/requests/billing_detail";

/** 売上請求管理(請求管理) 一括仮締め */
import DriverSalesRequestBillingConfirm from "./sales/requests/billing_confirm";

/** 売上請求管理 本締め処理*/
import DriverSalesClosingProcess from "./sales/requests/closing_process";

/** 売上請求管理 計上処理*/
import DriverSalesBillingProcess from "./sales/requests/billing_process";

/** 売上請求管理(Freee請求管理) 一覧 */
import DriverSalesFreeeTransaction from "./sales/freee_transaction";

/** 排出事業者招待 */
import DriverEmission from "./emission";

/** データ集計 マニフェスト集計 */
import DriverReportManifest from "./reports/manifest";

/** データ集計 交付等状況出力報告書 */
import DriverReportIssuanceStatus from "./reports/issuance_status";

/** データ集計 行政報告データ出力 */
import DriverReportGovernment from "./reports/government";

/** お知らせ */
import DriverNotification from "./notification";

/** お知らせ未読数 */
import DriverNotificationAlert from "./notification_alert";

import DriverNotificationBulkRead from "./notifications/bulk_read";
/** 処分状況 */
import DriverDisposalFlow from "./disposal_flow";

import DriverManifestDraftDisposalFlow from "./disposal_flows/manifest_draft";

import DriverManifestDraftTransportDisposalFlow from "./disposal_flows/manifest_draft_transport";

/** テナント */
import DriverMasterTenant from "./masters/tenant";

/** テナント(APIキー発行用) */
import DriverMasterTenantApi from "./masters/tenant_api";

/** 品目 */
import DriverMasterHandleItem from "./masters/handle_item";

/** 品目マスタ */
import DriverMasterItem from "./masters/item";

/** 排出事業者マスタ */
import DriverMasterEmission from "./masters/emission";

/** 排出事業場CSV出力 */
import DriverMasterOutputCsvEmissionLocation from "./masters/emission_location";

/** 排出事業者事業場マスタ */
import DriverMasterEmissionLocation from "./masters/emissions/location";

/** 排出事業者登録パターンマスタ */
import DriverMasterEmissionEntryPattern from "./masters/emissions/entry_pattern"


/** 排出事業者 事業場削除確認 */
import DriverMasterEmissionLocationRemoveConfirmation from "./masters/emissions/locations/remove_confirmation";

/** 排出事業者 取扱品目 */
import DriverMasterEmissionItem from "./masters/emissions/item";
/** 排出事業者担当者 */
import DriverMasterEmissionUser from "./masters/emissions/user";
/** 排出事業者招待 */
import DriverMasterEmissionInvitationUser from "./masters/emissions/invitation_user";

/** 収集運搬業者 */
import DriverMasterTransport from "./masters/transport";
/** 請求先 */
import DriverMasterBillingAddress from "./masters/billing_address";
/** 請求先 事業者重複チェック */
import DriverMasterBillingAddressRestrictionConfirm from "./masters/billing_address/restriction_confirm";

/** 最終処分場 */
import DriverMasterFinalDisposalSite from "./masters/final_disposal_site";
/** 処分業者 */
import DriverMasterDisposer from "./masters/disposer";
/** 収運処分業者 */
import DriverMasterTrader from "./masters/trader";
/** ユーザー */
import DriverMasterUser from "./masters/user";
/** 運搬ルート */
import DriverMasterTransportRoute from "./masters/transport_routes";
/** 運搬ルート コードチェック */
import DriverMasterTransportRouteCodeValidation from "./masters/transport_routes/code_validation";

/** 排出事業者(DXE) */
import DriverMasterDxeEmission from "./masters/dxe_emission";

/** 公共積替 */
import DriverMasterPublicPlace from "./masters/public_place";

/** JWNET未加入業者 */
import DriverMasterNonSubscribeTrader from "./masters/non_subscribe_trader";

/** JWNET未加入業者事業場 */
import DriverMasterNonSubscribeTraderLocation from "./masters/non_subscribe_traders/location";

/** 報告不要業者 */
import DriverMasterNonReportingTrader from "./masters/non_reporting_trader";

/** 報告不要業者事業場 */
import DriverMasterNonReportingTraderLocation from "./masters/non_reporting_traders/location";

/** 車両 */
import DriverMasterVehicle from "./masters/vehicle";

/** 一般廃棄物品目 */
import DriverMasterGeneralItem from "./masters/general_item";

/** 処理後物 */
import DriverMasterRecycleDisposedItem from "./masters/recycle_disposed_item";

/** 行政報告換算報告係数 */
import DriverMasterConversionFactorDetail from "./masters/conversion_factor_detail";

/** カスタム表示ラベル */
import DriverMasterCustomLabel from "./masters/custom_label";

/** ↓共通利用 */
/**  */
import DriverMasterSearchTrader from "./masters/search/trader";
/** 事業場 */
import DriverMasterSearchTraderLocation from "./masters/search/traders/location";
/**  */
/**  */
import DriverMasterSearchEmissionLocation from "./masters/search/emissions/location";
/**  */
import DriverMasterSearchEmissionDeliverer from "./masters/search/emissions/deliverer";
/**  */
import DriverMasterSearchEmissionRegister from "./masters/search/emissions/register";
/** 排出事業者の検索ダイアログ(回収新規・マニフェスト新規) */
import DriverMasterSearchEmissionDetail from "./masters/search/emission_detail";
/** 収運・処分事業者/事業場検索ダイアログ */
import DriverMasterSearchTraderDetail from "./masters/search/trader_detail";

/** 排出事業者の検索ダイアログ */
import DriverMasterSearchTenantDisposerDetail from "./masters/search/tenant_disposer_detail";
/** 取引先 排出事業者の検索ダイアログ(請求先) */
import DriverMasterSearchEmissionMember from "./masters/search/emission_member";
/** 取引先 業者の検索ダイアログ(請求先) */
import DriverMasterSearchTraderMember from "./masters/search/trader_member";

/** 収運・処分事業場検索(infiniteAutoCompleteで利用) */
import DriverMasterSearchTraderLocationMember from "./masters/search/trader_location_member";

/** 請求先 業者の検索ダイアログ(排出) */
import DriverMasterSearchBillingAddressMember from "./masters/search/billing_address_member";
/** 品目一覧取得 */
import DriverMasterSearchItem from "./masters/search/item";
/** 一般廃棄物品目一覧取得 */
import DriverMasterSearchGeneralItem from "./masters/search/general_item";
/** 荷姿一覧取得 */
import DriverMasterSearchPacking from "./masters/search/packing";
/** 有害物質一覧取得 */
import DriverMasterSearchHazardousSubstance from "./masters/search/hazardous_substance";
/** 運搬方法一覧取得 */
import DriverMasterSearchTransportation from "./masters/search/transportation";
/** 数量単位一覧取得 */
import DriverMasterSearchQuantityUnit from "./masters/search/quantity_unit";
/** 売上品目単位一覧取得 */
import DriverMasterSearchSalesItemUnit from "./masters/search/sales_item_unit";
/** 処分方法一覧取得 */
import DriverMasterSearchDisposalMethod from "./masters/search/disposal_method";
/** 数量確定者一覧取得 */
import DriverMasterSearchQuantityConfirm from "./masters/search/quantity_confirm";

/** 再資源化処分場処理方法 */
import DriverMasterRecycleDisposerDisposalMethod from "./masters/recycle_disposer_disposal_method";

/** 再資源化処理フロー */
import DriverMasterRecycleDisposalFlow from "./masters/recycle_disposal_flow";

/** テナント処理後物 */
import DriverMasterSearchRecycleDisposedItem from "./masters/search/recycle_disposed_item"

/** テナント処理方法 */
import DriverMasterSearchRecycleDisposalMethod from './masters/search/recycle_disposal_method'

/** 再資源化処分場処理方法 */
import DriverMasterSearchRecycleDisposerDisposalMethod from "./masters/search/recycle_disposer_disposal_method"

/** 再資源化 処分事業者 */
import DriverMasterSearchRecycleDisposer from './masters/search/recycle_disposer'

/** 再資源化等パターン展開 */
import DriverMasterSearchRecycleDisposalPattern from './masters/search/recycle_disposal_pattern'


/** 運搬ルート一覧取得 */
import DriverMasterSearchTransportRoute from "./masters/search/transport_route";
import DriverMasterSearchMembersTransportRoute from "./masters/search/members/transport_route";
/** カスタム表示ラベル取得 */
import DriverMasterSearchCustomLabel from "./masters/search/custom_label";
/** 車両検索 */
import DriverMasterSearchVehicle from "./masters/search/vehicle";
/** ドライバー検索 */
import DriverMasterSearchDriver from "./masters/search/driver";
/** ユーザー検索 */
import DriverMasterSearchUser from "./masters/search/user";
/** 処分方法（処分） */
import DriverMasterSearchAfterRecycleMethod from './masters/search/after_recycle_method'

/** 一般廃棄物処分業者 */
import DriverMasterGeneralWasteDisposal from "./masters/general_waste_disposal";

/** 一般廃棄物処分業者 事業場 */
import DriverMasterGeneralWasteDisposalLocation from "./masters/general_waste_disposals/location";

/** 排出事業者 */
import DriverMasterSearchEmission from "./masters/search/emission";

import DriverMasterSearchEmissionWorkplace from "./masters/search/emission_workplace";

/** 郵便番号検索 */
import DriverMasterSearchZipCode from "./masters/search/zip_code";

/** 住所(市町村)検索 */
import DriverMasterSearchAddressesCity from "./masters/search/addresses/city";

/** 住所(町域)検索 */
import DriverMasterSearchAddressesTown from "./masters/search/addresses/town";

/** 起票ユーザー */
import DriverMasterSearchVoteStaff from "./masters/search/vote_staff";

/** 引渡担当者・登録担当者へ登録可能ユーザー検索(ドライバー以外のユーザー) */
import DriverMasterSearchHandleUser from "./masters/search/handle_user";
/** テナント検索 */
import DriverMasterSearchTenant from "./masters/search/tenant";
/** 金融機関検索 */
import DriverMasterSearchBank from "./masters/search/bank";
/** 金融機関支店検索 */
import DriverMasterSearchBranch from "./masters/search/branch";
/** 最終処分場検索 */
import DriverMasterSearchFinalDisposalSite from "./masters/search/final_disposal_site";
/** テナントが管理する事業場一覧取得 */
import DriverMasterSearchTenantTraderLocation from "./masters/search/tenants/trader_location";
/** テナントが管理する処分事業者 */
import DriverMasterSearchTenantDisposal from "./masters/search/tenants/disposal";
/** テナントが管理する収運・処分事業者 */
import DriverMasterSearchTenantTrader from "./masters/search/tenants/trader";
/** 取引先品目単価 */
import DriverMasterSearchEmissionSalesItemPriceDetail from "./masters/search/emissions/sales_item_price_detail";

/** 取引先 */
import DriverMasterSearchSupplier from "./masters/search/supplier";

/** 取引先売上品目 */
import DriverMasterSearchSupplierSalesItemPriceDetail from "./masters/search/suppliers/sales_item_price_detail";

/** 請求先 */
import DriverMasterSearchBillingAddress from "./masters/search/billing_address";

import DriverTenantUserRegistrationDecision from "./tenant/user_registration_decision";

/** 営業担当者 */
import DriverMasterSearchSalesStaff from "./masters/search/sales_staff";

/** 車両CSV入出力 */
import DriverSettingVehicle from "./settings/vehicle";
/** ユーザーCSV入出力 */
import DriverSettingUser from "./settings/user";
/** 排出事業者CSV入出力 */
import DriverSettingEmission from "./settings/emission";
/** 排出事業場CSV入出力 */
import DriverSettingEmissionLocation from "./settings/emission_location";
/** 収集運搬業者CSV入出力 */
import DriverSettingTransport from "./settings/transport";
/** 処分業者CSV入出力 */
import DriverSettingDisposer from "./settings/disposer";
/** 売上CSV出力 */
import DriverSettingDeal from "./settings/deal";
/** 請求CSV出力 */
import DriverSettingBillingTransaction from "./settings/billing_transaction";
/** 売上品目単価CSV入出力 */
import DriverSettingBillingAddress from "./settings/billing_address";
/** 処分方法CSV入出力 */
import DriverSettingRecycleDisposalMethod from "./settings/recycle_disposal_method";
/** 処理後物CSV入出力 */
import DriverSettingRecycleDisposedItem from "./settings/recycle_disposed_item";
/** マニフェストCSV入出力 */
import DriverSettingManifest from "./manifest/settings/management";
/** 受注CSV入出力 */
import DriverSettingOrder from "./settings/order";

/***/
import DriverCsvImportTask from "./csv_import_task";

import DriverPdfOutputTask from "./pdf_output_task";

/** テナント設定 */
import DriverTenantConfiguration from "./tenant/configuration";

import DriverProvider from "./provider";

/** 外部サービス連携 コールバック */
import DriverProviderCallback from "./providers/callback";

/** 外部サービス連携 freee事業所 */
import DriverProviderFreeeCompany from "./providers/freee/company";

/** 外部サービス連携 freee取引先 */
import DriverProviderFreeePartner from "./providers/freee/partner";

/** 売上品目単位 */
import DriverMasterSalesItemUnit from "./masters/sales_item_unit";
/** 売上品目単価 */
import DriverMasterSalesItemPrice from "./masters/sales_item_price";
/** 売上品目単価CSV入出力 */
import DriverSettingSalesItemPrice from "./settings/sales_item_price";
/** 売上品目単価（取引先品目単価） */
import DriverMasterSupplierSalesItemPrice from "./masters/suppliers/sales_item_price";
/** 売上品目単価（取引先品目単価）CSV入出力 */
import DriverMasterSupplierSalesItemPriceOutputReservation from "./masters/suppliers/sales_item_prices/output_reservation";

/** 税率の取得 */
import DriverMasterSearchTaxRate from "./masters/search/tax_rate";

/** 郵便番号から住所取得 city */
import DriverMasterSearchJipCode from "./masters/search/jipcode";

/** ■新配車計画 */

/** ドライバー */
import DriverAllocationDriver from "./allocations/driver";

/** ドライバースケジュール */
import DriverAllocationDriverSchedule from "./allocations/drivers/schedule";

/** 最終保存日時 */
import DriverAllocationLastUpdate from "./allocations/last_update";

/** 受注一覧 */
import DriverAllocationUnassignedOrder from "./allocations/unassigned_order";

/** 受注(至急)一覧 */
import DriverAllocationUnassignedUrgentOrder from "./allocations/unassigned_urgent_order";

/** 受注(いつでも)一覧 */
import DriverAllocationUnassignedAnytimeOrder from "./allocations/unassigned_anytime_order";

/** その他配車指示を入力 */
import DriverAllocationDriverInstruction from "./allocations/drivers/instruction";

/** ドライバー指示メモ */
import DriverAllocationOrderInstruction from "./allocations/orders/instruction";

/** 車両を指定 */
import DriverAllocationDriverScheduleVehicle from "./allocations/drivers/schedules/vehicle";

/** 受注モーダル */
import DriverAllocationUnregisteredOrder from "./allocations/unregistered_order";

/** ドライバー入れ替え */
import DriverAllocationDriverSwitching from "./allocations/drivers/switching";

/** 配車確定 */
import DriverAllocationAllocate from "./allocations/allocate";

/** ドライバー引当 */
import DriverAllocationDriverAssign from "./allocations/drivers/assign";

/** 配車をすべて削除 */
import DriverAllocationDriverRelease from "./allocations/drivers/release";

/** ■新配車計画 */

/** 出力ファイル */
import DriverOutputFile from "./output_file";

/** 産廃回収編集 変更確認 */
import DriverOrdersCollectionVerifyOrderManifest from "./orders/accepts/collections/verifies/order_manifest";

/**  産廃回収詳細 回収日編集 変更確認 */
import DriverOrdersCollectionVerifyCollect from "./orders/accepts/collections/verifies/collect";

/**  産廃回収詳細 連絡番号編集 変更確認 */
import DriverOrdersCollectionVerifyContactNumber from "./orders/accepts/collections/verifies/contact_number";

/**  産廃回収詳細 処分事業場編集 変更確認 */
import DriverOrdersCollectionVerifyDisposerLocation from "./orders/accepts/collections/verifies/disposer_location";

/**  産廃回収詳細 排出事業者編集 変更確認 */
import DriverOrdersCollectionVerifyEmission from "./orders/accepts/collections/verifies/emission";

/**  産廃回収詳細 運搬先事業場編集 変更確認 */
import DriverOrdersCollectionVerifyTransportLocation from "./orders/accepts/collections/verifies/transport_location";

/**  産廃回収詳細 JWNET備考編集 変更確認 */
import DriverOrdersCollectionVerifyTransportNote from "./orders/accepts/collections/verifies/transport_note";

/**  産廃回収詳細 廃棄物情報編集 変更確認 */
import DriverOrdersCollectionVerifyWaste from "./orders/accepts/collections/verifies/waste";

/**  マニフェスト詳細 回収日編集 変更確認 */
import DriverManifestManagementVerifyCollect from "./manifest/managements/verifies/collect";

/**  マニフェスト詳細 連絡番号編集 変更確認 */
import DriverManifestManagementVerifyContactNumber from "./manifest/managements/verifies/contact_number";

/**  マニフェスト詳細 処分事業場編集 変更確認 */
import DriverManifestManagementVerifyDisposerLocation from "./manifest/managements/verifies/disposer_location";

/**  マニフェスト詳細 排出事業者編集 変更確認 */
import DriverManifestManagementVerifyEmission from "./manifest/managements/verifies/emission";

/**  マニフェスト詳細 運搬先事業場編集 変更確認 */
import DriverManifestManagementVerifyTransportLocation from "./manifest/managements/verifies/transport_location";

/**  マニフェスト詳細 JWNET備考編集 変更確認 */
import DriverManifestManagementVerifyTransportNote from "./manifest/managements/verifies/transport_note";

/**  マニフェスト詳細 廃棄物情報編集 変更確認 */
import DriverManifestManagementVerifyWaste from "./manifest/managements/verifies/waste";

/** マニフェスト回収履歴 */
import DriverManifestHistory from "./manifest/history"

/** JWNETデータ取込 */
import DriverTransfer from "./transfer";

/**
 * JWNETデータ取込
 * 紐付け処理
 */
import DriverTransferAutoConfiguration from "./transfers/auto_configuration";

/**
 * JWNETデータ取込
 * 排出事業者データ補完
 */
import DriverTransferEmissionComplement from "./transfers/emission_complement";

/**
 * JWNETデータ取込
 * 排出事業者データ補完 排出事業者モーダル
 */
import DriverTransferEmission from "./transfers/emission";

/**
 * JWNETデータ取込
 * 収運・処分業者データ補完
 */
import DriverTransferTraderComplement from "./transfers/trader_complement";

/**
 * JWNETデータ取込
 * 収運・処分業者データ補完 データ登録
 */
import DriverTransferTrader from "./transfers/trader";

/**
 * JWNETデータ取込
 * 報告不要業者データ補完
 */
import DriverTransferNoneReportTraderComplement from "./transfers/none_report_trader_complement";

/**
 * JWNETデータ取込
 * 報告不要業者データ補完 報告不要業者モーダル
 */
import DriverTransferNoneReportTrader from "./transfers/none_report_trader";

/**
 * JWNET（WEB）データ取込
 * 公共積替事業場一覧
 * */
import DriverTransferPublicPlaceComplement from "./transfers/public_place_complement";

/**
 * JWNET（WEB）データ取込
 * 公共積替事業場登録
 */
import DriverTransferPublicPlace from "./transfers/public_place";

/**
 * JWNETデータ取込
 * 取込
 */
import DriverTransferImport from "./transfers/import";

/**
 * JWNETデータ取込
 * 削除
 */
import DriverTransferRemove from "./transfers/remove";

/**
 * ドライバースケジュール
 * 未引当受注一覧
 */
import DriverScheduleUnassignedOrder from "./driver_schedules/unassigned_order";

import DriverScheduleSchedule from "./driver_schedules/schedule";

/**
 * ドライバースケジュール
 * 作業登録
 */

/**  新配車計画　作業登録 */
import DriverScheduleInstruction from "./driver_schedules/instruction";

/**  新配車計画　作業登録 履歴 */
import DriverScheduleInstructionHistory from "./driver_schedules/instruction_history";

/** ドライバースケジュール 並び順設定 */
import DriverScheduleSortSetting from "./driver_schedules/sort_setting";

/** ドライバースケジュール 指示メモ */
import DriverScheduleOrderInstruction from "./driver_schedules/order_instruction";

/** ドライバースケジュール 現地指示メモ */
import DriverScheduleOrderLocal from "./driver_schedules/order_local";

/** ドライバースケジュール 並び替え */
import DriverScheduleScheduleSortPriority from "./driver_schedules/schedule_sort_priority";

/** ドライバー設定 */
import DriverScheduleDriverSetting from "./driver_schedules/driver_setting";

/** 受注の紐付けをすべて解除 */
import DriverScheduleBulkDeletion from "./driver_schedules/bulk_deletion";

/** 受注紐付け */
import DriverScheduleAssociationOrder from "./driver_schedules/association_order";

/** ドライバースケジュール　ドライバー検索 */
import SearchDriverScheduleDriver from "./masters/search/driver_schedules/driver";

/** ■トピック表示 */

/** トピック取得 */
import DriverTopic from "./driver_topic";

/** 郵便番号からの住所検索 */
import DriverAddress from "./address";

/** 検索パターン */
import DriverMasterConditionPattern from "./masters/condition_pattern";

/** 自テナント処分業者 */
import DriverMasterMemberTenantDisposer from "./masters/search/members/tenant_disposer"

/** 自テナント処分事業場 */
import DriverMasterMemberTenantDisposerLocation from "./masters/search/members/tenant_disposer_location"

/** 受注回収履歴 */
import DriverOrderHistory from "./orders/history"

/** 登録パターン */
import DriverMasterEntryPattern from './masters/entry_pattern'

/** 処分方法 */
import DriverMasterRecycleDisposalMethod from "./masters/recycle_disposal_method";


/** recycle_disposal_pattern_condition */
import DriverMasterRecycleDisposalPatternCondition from './masters/recycle_disposal_pattern_condition'
/** 再資源化換算係数 */
import DriverMasterRecycleConversionFactorDetail from "./masters/recycle_conversion_factor_detail";

/** 2次マニ 処分最終、最終処分終了報告登録前1次マニ反映確認 */
import DriverManifestPrimaryManifestSyncCheck from "./manifest/recycle_disposal_reports/primary_manifest_sync_check"

/** マニフェスト種別のチェック処理 */
import DriverFinalDisposalManifestTypeCheck from "./manifest/final_disposal_reports/manifest_type_check"

import DriverMasterAfterDisposalItem from "./masters/after_disposal_item";

/** 処理後物品目一覧取得 */
import DriverMasterSearchAfterDisposalItem from "./masters/search/after_disposal_item";

/** 処理後物品目(大分類) TODO 未使用かも */
import DriverMasterSearchAfterDisposalItemCategory from "./masters/search/after_disposal_item_category"

/** 処理後物の種類 TODO 未使用かも */
import DriverMasterSearchAfterDisposalItemSubcategory from "./masters/search/after_disposal_item_subcategory"

/** マニフェスト詳細 再資源化等処理情報 */
import DriverManifestManagementManifestRecycleDisposalReport from "./manifest/managements/manifest_recycle_disposal_report"

/** 処理後物品目（大分類） */
import DriverMasterSearchRecycleDisposedItemCategory from "./masters/search/recycle_disposed_item_category"

/** 処理後物の種類 */
import DriverMasterSearchRecycleDisposedItemSubcategory from "./masters/search/recycle_disposed_item_subcategory"

/** 処分場処理方法に紐付く処分前廃棄物種類ID */
import DriverMasterSearchRecycleDisposerDisposalMethodItem from './masters/search/recycle_disposer_disposal_methods/item'

import DriverManifestFirstManifestIncludedRecycleCheck from "./manifest/disposal_reports/first_manifest_included_recycle_check"

const DriverModules = {
  modules: {
    DriverAllocationDriver,
    DriverAllocationDriverSchedule,
    DriverAllocationLastUpdate,
    DriverAllocationUnassignedOrder,
    DriverAllocationUnassignedUrgentOrder,
    DriverAllocationUnassignedAnytimeOrder,
    DriverAllocationDriverInstruction,
    DriverAllocationOrderInstruction,
    DriverAllocationDriverScheduleVehicle,
    DriverAllocationUnregisteredOrder,
    DriverAllocationDriverSwitching,
    DriverAllocationAllocate,
    DriverAllocationDriverAssign,
    DriverAllocationDriverRelease,

    DriverAuthentication,
    DriverInitialPassword,
    DriverAppVariable,
    DriverMe,
    DriverProviderSetting,
    DriveContractAuthorize,
    DriverTenant,
    DriverRecovery,
    DriverForget,
    DriverActivate,
    DriverProviderCallback,
    DriverProviderFreeeCompany,
    DriverProviderFreeePartner,

    DriverDashboardCollect,
    DriverDashboardDrafting,
    DriverDashboardManifest,
    DriverDashboardAccepts,
    DriverDashboardDriver,
    DriverDashboardDriverStatus,
    DriverDashboardTenantTask,
    DriverDashboardFailureReport,

    DriverOrderReceiveSummary,
    DriverOrderReceiveCompletion,
    DriverOrderReceiveFinalCompletion,

    DriverOrderAccept,
    DriverOrderAcceptOutputReservation,
    DriverOrderAcceptBackorder,
    DriverOrderAcceptSummary,
    DriverOrderSearchAccept,
    DriverOrderAcceptCollectionRevisionHistory,
    DriverOrderAcceptCollectionCollect,
    DriverOrderAcceptCollectionEmission,
    DriverOrderAcceptCollectionDriverInstruction,
    DriverOrderAcceptCollectionWaste,
    DriverOrderAcceptCollectionContactNumber,
    DriverOrderAcceptCollectionTransportNote,
    DriverOrderAcceptCollectionTransportLocation,
    DriverOrderAcceptCollectionDisposerLocation,
    DriverOrderAcceptCollectionSendMailApproval,

    DriverOrdersAcceptManifest,
    DriverOrderAcceptCollectionReservation,
    DriverOrderAcceptCollectionCancellation,
    DriverOrderSelfEmissionReservation,
    DriverOrderSelfEmissionDefinitiveRegistration,
    DriverOrderAcceptDuplicateOrder,

    DriverOrderAcceptCollection,
    DriverOrderAcceptCollectionProvisional,
    DriverOrderAcceptCollectionRegistration,
    DriverOrderAcceptCollectionRegistrationReception,
    DriverOrderAcceptCollectionRegistrationProvisional,
    DriverOrderAcceptCollectionRegistrationRejection,

    DriverOrderAcceptPickup,
    DriverOrderAcceptPickupRegistration,
    DriverOrderAcceptPickupRegistrationReception,
    DriverOrderAcceptPickupRegistrationRejection,

    DriverOrderAcceptCarryIn,
    DriverOrderAcceptCarryInRegistration,
    DriverOrderAcceptCarryInRegistrationReception,
    DriverOrderAcceptCarryInsRegistrationRejection,

    DriverOrderAcceptDirectlyCancel,
    DriverOrderAcceptDirectlyHidden,
    DriverOrderAcceptDirectlyComplete,

    DriverOrderRequest,
    DriverOrderSummary,
    DriverOrderRequestsPickup,
    DriverOrderRequestsCarryIn,
    DriverOrderRequestsDirectlyComplete,

    DriverManifestRequest,
    DriverManifestMapRequest,
    DriverManifestRequestsCarryIn,
    DriverManifestRequestsPickup,
    DriverManifestConfirmationSlip,
    DriverManifestConfirmationList,
    DriverJwnetJoinApplicationForm,
    DriverJwnetEdiApplicationForm,

    DriverAcceptance,
    DriverAcceptanceDirectlyComplete,

    DriverManifest,
    DriverManifestLinkage,
    DriverManifestLinkageVerification,
    DriverManifestLinkageRegistration,
    DriverManifestLinkageReservation,
    DriverManifestSummary,
    DriverDuplicateManifest,
    DriverDuplicateManifestDetail,
    DriverManifestPreviously,
    DriverManifestRelation,
    DriverManifestManifestDetail,
    DriverManifestMaintenanceEmission,
    DriverManifestMaintenanceCollectionReport,
    DriverManifestMaintenanceDriverInstruction,
    DriverManifestMaintenanceCollect,
    DriverManifestMaintenanceWaste,
    DriverManifestMaintenanceTransportComplete,
    DriverManifestMaintenanceNote,
    DriverManifestMaintenanceTransportLocation,
    DriverManifestMaintenanceDisposerLocation,
    DriverOrderConfirmationSlip,
    DriverOrderConfirmationList,
    DriverOrderReportConfirmationVerification,
    DriverOrderConfirmationSlipVerification,
    DriverOrderConfirmationListVerification,
    DriverOrderCompletionReport,
    DriverOrderDisposalReport,
    DriverOrderFinalDisposalReport,
    DriverOrderRecycleFinalDisposalReport,
    DriverManifestChangeHistory,
    DriverManifestReservationProcess,
    DriverManifestCompletionProcess,
    DriverSalesDeal,
    DriverSalesDealProvisional,
    DriverSalesDealReception,
    DriverSalesDealOutput,
    DriverSalesDealDuplicate,
    DriverSalesRequest,
    DriverSalesRequestBillingDetail,
    DriverSalesRequestBillingConfirm,
    DriverSalesClosingProcess,
    DriverSalesBillingProcess,
    DriverSalesFreeeTransaction,

    DriverAllocateEntryDriver,
    DriverAllocateEntryLastUpdate,
    DriverAllocateEntryDriverSchedule,
    DriverAllocateEntryDriverScheduleVehicle,
    DriverAllocateEntryManifestDriverInstruction,
    DriverAllocateInstructionHistory,
    DriverAllocateEntryDriverInstruction,
    DriverAllocateEntryDriverDestination,
    DriverAllocateEntryDriverAssign,
    DriverAllocateEntryDriverRelease,
    DriverAllocateEntryDriverDispatchedSchedule,
    DriverAllocateEntrySwitchDriver,
    DriverAllocateEntryDispatch,
    DriverAllocateEntryNonAllocation,
    DriverAllocateEntryUrgentAllocation,
    DriverAllocateEntryUnspecifiedAllocation,
    DriverAllocateEntryAssign,

    DriverDisposalFlow,
    DriverManifestDraftDisposalFlow,
    DriverManifestDraftTransportDisposalFlow,

    DriverManifestManagement,
    DriverManifestManagementOutputReservation,
    DriverManifestManagementRegistration,
    DriverManifestManagementReservation,
    DriverManifestManagementsManifest,
    DriverManifestManagementsManifestTransport,
    DriverManifestManagementOrder,
    DriverManifestManagementDuplicate,
    DriverManifestManagementDisposal,
    DriverManifestManagementFinalDisposal,
    DriverManifestRestManifest,
    DriverManifestRestManifestManifest,
    DriverManifestRestManifestTransport,
    DriverManifestRestManifestDisposal,
    DriverManifestRestManifestFinalDisposal,
    DriverManifestManagementEmission,
    DriverManifestManagementWaste,
    DriverManifestManagementCollect,
    DriverManifestManagementContactNumber,
    DriverManifestManagementTransportNote,
    DriverManifestManagementTransportLocation,
    DriverManifestManagementDisposerLocation,
    DriverManifestManagementManifestCustomLabel,
    DriverManifestManagementSendMailApproval,
    DriverManifestPaperRegister,
    DriverManifestManagementManifestSearchKeyword,
    DriverManifestReportConfirmationVerification,
    DriverManifestConfirmationSlipVerification,
    DriverManifestConfirmationListVerification,
    DriverManifestBulkRegistManifest,
    DriverManifestCompletionReport,
    DriverManifestDisposalReport,
    DriverManifestFinalDisposalReport,
    DriverManifestRecycleFinalDisposalReport,

    DriverEmission,
    DriverReportManifest,
    DriverReportIssuanceStatus,
    DriverReportGovernment,
    DriverNotification,
    DriverNotificationAlert,
    DriverNotificationBulkRead,

    DriverProvider,
    DriverMasterTenant,
    DriverMasterTenantApi,
    DriverMasterItem,
    DriverMasterHandleItem,
    DriverMasterEmission,
    DriverMasterOutputCsvEmissionLocation,
    DriverMasterEmissionLocation,
    DriverMasterEmissionLocationRemoveConfirmation,
    DriverMasterEmissionEntryPattern,

    DriverMasterEmissionItem,
    DriverMasterEmissionUser,
    DriverMasterEmissionInvitationUser,
    DriverMasterBillingAddress,
    DriverMasterBillingAddressRestrictionConfirm,
    DriverMasterTransport,
    DriverMasterFinalDisposalSite,
    DriverMasterDisposer,
    DriverMasterTrader,
    DriverMasterUser,
    DriverMasterTransportRoute,
    DriverMasterTransportRouteCodeValidation,
    DriverMasterSearchEmissionSalesItemPriceDetail,
    DriverMasterConversionFactorDetail,
    DriverMasterCustomLabel,

    DriverMasterSearchTrader,
    DriverMasterSearchTraderLocation,
    DriverMasterSearchEmissionLocation,
    DriverMasterSearchEmissionDeliverer,
    DriverMasterSearchEmissionRegister,
    DriverMasterSearchEmissionDetail,
    DriverMasterSearchTraderDetail,
    DriverMasterSearchTenantDisposerDetail,
    DriverMasterSearchEmissionMember,
    DriverMasterSearchTraderMember,
    DriverMasterSearchTraderLocationMember,
    DriverMasterSearchBillingAddressMember,
    DriverMasterSearchItem,
    DriverMasterSearchGeneralItem,
    DriverMasterSearchPacking,
    DriverMasterSearchHazardousSubstance,
    DriverMasterSearchTransportation,
    DriverMasterSearchQuantityUnit,
    DriverMasterSearchSalesItemUnit,
    DriverMasterSearchDisposalMethod,
    DriverMasterSearchQuantityConfirm,
    DriverMasterRecycleDisposerDisposalMethod,
    DriverMasterRecycleDisposalFlow,
    DriverMasterSearchRecycleDisposedItem,
    DriverMasterSearchRecycleDisposalMethod,
    DriverMasterSearchRecycleDisposerDisposalMethod,
    DriverMasterSearchRecycleDisposer,
    DriverMasterSearchRecycleDisposalPattern,

    DriverMasterSearchTransportRoute,
    DriverMasterSearchMembersTransportRoute,
    DriverMasterSearchCustomLabel,
    DriverMasterSearchVehicle,
    DriverMasterSearchDriver,
    DriverMasterSearchUser,
    DriverMasterSearchVoteStaff,
    DriverMasterSearchHandleUser,
    DriverMasterSalesItemUnit,
    DriverMasterSalesItemPrice,
    DriverMasterSearchTenant,
    DriverMasterSearchBank,
    DriverMasterSearchBranch,
    DriverMasterSearchTenantTraderLocation,
    DriverMasterSearchTenantDisposal,
    DriverMasterSearchTenantTrader,
    DriverMasterSearchFinalDisposalSite,
    DriverMasterSearchSupplier,
    DriverMasterSearchSupplierSalesItemPriceDetail,

    DriverMasterSearchBillingAddress,

    DriverMasterSearchSalesStaff,

    DriverMasterSearchEmission,
    DriverMasterSearchEmissionWorkplace,

    DriverMasterSearchAfterRecycleMethod,

    DriverMasterSupplierSalesItemPrice,
    DriverMasterSupplierSalesItemPriceOutputReservation,
    DriverTenantUserRegistrationDecision,

    DriverMasterDxeEmission,
    DriverMasterPublicPlace,
    DriverMasterNonSubscribeTrader,
    DriverMasterNonSubscribeTraderLocation,
    DriverMasterNonReportingTrader,
    DriverMasterNonReportingTraderLocation,
    DriverMasterVehicle,
    DriverMasterGeneralItem,
    DriverMasterRecycleDisposedItem,
    DriverMasterSearchZipCode,
    DriverMasterSearchAddressesCity,
    DriverMasterSearchAddressesTown,

    DriverMasterGeneralWasteDisposal,
    DriverMasterGeneralWasteDisposalLocation,

    DriverSettingDeal,
    DriverSettingVehicle,
    DriverSettingUser,
    DriverSettingSalesItemPrice,
    DriverSettingEmission,
    DriverSettingEmissionLocation,

    DriverSettingTransport,
    DriverSettingDisposer,
    DriverSettingBillingTransaction,
    DriverSettingBillingAddress,
    DriverSettingRecycleDisposalMethod,
    DriverSettingRecycleDisposedItem,
    DriverSettingManifest,
    DriverSettingOrder,

    DriverCsvImportTask,
    DriverPdfOutputTask,

    DriverTenantConfiguration,
    DriverMasterSearchTaxRate,
    DriverMasterSearchJipCode,
    DriverOutputFile,

    DriverOrdersCollectionVerifyOrderManifest,
    DriverOrdersCollectionVerifyCollect,
    DriverOrdersCollectionVerifyContactNumber,
    DriverOrdersCollectionVerifyDisposerLocation,
    DriverOrdersCollectionVerifyEmission,
    DriverOrdersCollectionVerifyTransportLocation,
    DriverOrdersCollectionVerifyTransportNote,
    DriverOrdersCollectionVerifyWaste,

    DriverManifestManagementVerifyCollect,
    DriverManifestManagementVerifyContactNumber,
    DriverManifestManagementVerifyDisposerLocation,
    DriverManifestManagementVerifyEmission,
    DriverManifestManagementVerifyTransportLocation,
    DriverManifestManagementVerifyTransportNote,
    DriverManifestManagementVerifyWaste,
    DriverManifestHistory,

    DriverTransfer,
    DriverTransferAutoConfiguration,
    DriverTransferEmissionComplement,
    DriverTransferEmission,
    DriverTransferTraderComplement,
    DriverTransferTrader,
    DriverTransferPublicPlaceComplement,
    DriverTransferPublicPlace,
    DriverTransferNoneReportTraderComplement,
    DriverTransferNoneReportTrader,
    DriverTransferImport,
    DriverTransferRemove,

    DriverScheduleUnassignedOrder,
    DriverScheduleSchedule,
    DriverScheduleInstruction,
    DriverScheduleInstructionHistory,
    DriverScheduleSortSetting,
    DriverScheduleOrderInstruction,
    DriverScheduleOrderLocal,
    DriverScheduleScheduleSortPriority,
    DriverScheduleDriverSetting,
    DriverScheduleBulkDeletion,
    DriverScheduleAssociationOrder,
    SearchDriverScheduleDriver,

    DriverTopic,
    DriverAddress,
    DriverMasterConditionPattern,

    DriverMasterMemberTenantDisposer,
    DriverMasterMemberTenantDisposerLocation,

    DriverOrderHistory,

    DriverMasterEntryPattern,

    DriverMasterRecycleDisposalMethod,
    DriverMasterRecycleDisposalPatternCondition,
    DriverMasterRecycleConversionFactorDetail,

    DriverManifestPrimaryManifestSyncCheck,
    DriverFinalDisposalManifestTypeCheck,

    DriverMasterAfterDisposalItem,
    DriverMasterSearchAfterDisposalItem,
    DriverMasterSearchAfterDisposalItemCategory,
    DriverMasterSearchAfterDisposalItemSubcategory,
    DriverManifestManagementManifestRecycleDisposalReport,

    DriverMasterSearchRecycleDisposedItemCategory,
    DriverMasterSearchRecycleDisposedItemSubcategory,
    DriverMasterSearchRecycleDisposerDisposalMethodItem,

    DriverManifestFirstManifestIncludedRecycleCheck,

  },
};
export default DriverModules.modules;
